/** Auth-scoped identity for learner curriculum reads (not roster student row). */

function readStoredPlatformUserId(): string {
  if (typeof localStorage === 'undefined') return '';
  return (localStorage.getItem('X_USER_ID') || '').trim();
}

export function resolveLearnerCurriculumIdentity(opts: {
  tenantId?: string | null;
  platformUserId?: string | null;
}): { membershipKey: string; platformUserKey: string } {
  const tenantId =
    (opts.tenantId ?? '').trim() ||
    (typeof localStorage !== 'undefined' ? (localStorage.getItem('X_TENANT_ID') || '').trim() : '');
  const platformUserKey =
    (opts.platformUserId ?? '').trim() || readStoredPlatformUserId() || 'anonymous';
  const membershipKey = tenantId || 'no-tenant';
  return { membershipKey, platformUserKey };
}

/** Curriculum `/me` uses platform user + tenant from auth — not roster student id. */
export function isLearnerCurriculumIdentityReady(
  membershipKey: string,
  platformUserKey: string,
): boolean {
  return membershipKey !== 'no-tenant' && platformUserKey !== 'anonymous';
}
